import React, { Component } from "react";
import "./style.css";
import { Table, Row, Col, FormGroup, Input } from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";

import authAction from "../../redux/auth/action";
import fundPricesAction from "../../redux/fundPrices/action";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import api from "../../config/api";
import CustomButton from "../../component/CustomButton/CustomButton";
import PageHead from "../../component/pageHead/PageHead";
import { isNetworkRequestFailedError } from "../../config/helpers";

class GetFundPrice extends Component {
  state = {
    fundName: "",
    fundId: "",
    suggestedData: [],
    fundPrice: null,
    isLoading: false,
  };

  handlePriceInputChange = (e) => {
    const { allFunds, setCurrentFund, fundPrice } = this.props;
    const value = e.target.value;
    let filteredArr = [];

    if (value) {
      filteredArr = allFunds.filter((e) =>
        e.FUND_NAME.toLowerCase().includes(value.toLowerCase())
      );
    }

    setCurrentFund({ fundName: value, fundPrice });

    this.setState({ fundName: e.target.value, suggestedData: filteredArr });
  };

  // handleSuggestionClick = suggestion => {
  //   const { setCurrentFund, fundPrice } = this.props;

  //   setCurrentFund({ fundName: suggestion.FUND_NAME, fundPrice });
  //   this.setState({
  //     fundName: suggestion.FUND_NAME,
  //     fundId: suggestion.FUND_ID
  //   });
  // };

  onSelectChange = (e) => {
    const { allFunds } = this.props;

    const selectedId = parseInt(e.target.value);
    const selectedFund =
      allFunds.find((item) => item.FUND_ID === selectedId) || {};

    const { setCurrentFund } = this.props;
    const reduxPayload = {
      fundName: selectedFund.FUND_NAME,
      fundId: selectedFund.FUND_ID,
    };

    setCurrentFund(reduxPayload);

    this.setState({
      fundName: selectedFund.FUND_NAME,
      fundId: selectedFund.FUND_ID,
    });
  };

  fetchFundPrice = async () => {
    const { setAlertMessage, user, setCurrentFund, fundId, fundName } =
      this.props;

    try {
      if (!fundId) throw new Error("Please select Fund Name");

      this.setState({ isLoading: true });

      const response = await api.fetchCurrentPrice({ fundId }, user.token);
      this.setState({ fundPrice: response.data.result });
      setCurrentFund({ fundName, fundPrice: response.data.result, fundId });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.fetchFundPrice : null,
      });
    }

    this.setState({ isLoading: false });
  };

  render() {
    const { isLoading } = this.state;
    const { fundPrice, fundId, allFunds } = this.props;

    return (
      <div>
        <div className="current-fund-price-container">
          <Row className="flex1">
            <Col lg={9} md={9} sm={6} className="p-0 d-flex align-items-end">
              <FormGroup className="flex1">
                <Input
                  className="margin-y-10"
                  type="select"
                  name="select"
                  id="exampleSelect"
                  value={fundId || "placeholder"}
                  onChange={this.onSelectChange}
                >
                  <option value="placeholder" disabled>
                    Select Fund Name
                  </option>
                  {allFunds.map((item) => (
                    <option key={Math.random().toString()} value={item.FUND_ID}>
                      {item.FUND_NAME}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              {/* <InputComp
                suggestedData={suggestedData}
                onSuggestionClick={this.handleSuggestionClick}
                lookFor="FUND_NAME"
                onChange={this.handlePriceInputChange}
                value={fundName}
                name="rsa-pin"
                placeholder="Type fund name here..."
                inputContainerClasses={"margin-y-0 margin-left-right-0 flex1"}
                autoComplete={false}
                customAutoComplete={true}
                containerStyles={{ width: "100%" }}
              /> */}
            </Col>
            <Col lg={3} md={3} sm={6} className="mx-auto pl-0 pl-sm-3 pr-0">
              <CustomButton
                onClick={this.fetchFundPrice}
                buttonText="Search"
                buttonContainerClasses={"margin-y-10"}
                buttonStyle={{ width: "100%" }}
              />
            </Col>
          </Row>
        </div>
        {fundPrice && (
          <div>
            <PageHead
              title={fundPrice.FundName}
              containerStyles={{ width: "100%" }}
            />
            <Table borderless className="current-fund-price-table">
              <tbody>
                <tr className="second-row">
                  <th scope="row">Value Date</th>
                  <td>{moment(fundPrice.ValueDate).format("MMMM DD, YYYY")}</td>
                </tr>
                <tr className="second-row">
                  <th scope="row">Unit Price</th>
                  <td>{fundPrice.UnitPrice}</td>
                </tr>
              </tbody>
            </Table>
          </div>
        )}
        {isLoading && <CustomLoader />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  fundPrice: state.fundPrices.currentFund.fundPrice,
  fundName: state.fundPrices.currentFund.fundName,
  fundId: state.fundPrices.currentFund.fundId,
});

const mapDispatchToProps = {
  setAlertMessage: authAction.setAlertMessage,
  setCurrentFund: fundPricesAction.setCurrentFund,
};

export default connect(mapStateToProps, mapDispatchToProps)(GetFundPrice);
